import { falsyCheckDate } from 'utils/date';

export const DateDiv = ({ date }: { date: Nullable<string> }) => {
  return <div>{falsyCheckDate(date)}</div>;
};
